/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { isString } from 'lodash'

import MenuIcon from '../components/MenuIcon'

const DropdownMenuItem = ({ label, link, icon, onClick }) => (
    <li>
        {
            isString(link) ? (
                <Link to={ link }>
                    <MenuIcon icon={ icon } />
                    <span>{ label }</span>
                </Link>
            ) : (
                <a onClick={ onClick } role="menuitem">
                    <MenuIcon icon={ icon } />
                    <span>{ label }</span>
                </a>
            )
        }
    </li>
)

DropdownMenuItem.propTypes = {
    link    : PropTypes.string,
    label   : PropTypes.string,
    icon    : PropTypes.node,
    onClick : PropTypes.func
}

export default DropdownMenuItem
